import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl, AbstractControl } from '@angular/forms';
import { takeUntil } from "rxjs/operators";
import { sweetAlert } from "../../../utils/swal";
import { componentDestroyed } from "@w11k/ngx-componentdestroyed";
import { ActivatedRoute, Router } from "@angular/router";
import { PayorService } from 'src/app/service/payor/payor.service';
import { CorporateService } from '../../corporate-user/corporate-service/corporate-service';


@Component({
  selector: 'app-add-payor',
  templateUrl: './add-payor.component.html',
  styleUrls: ['./add-payor.component.css']
})
export class AddPayorComponent implements OnInit {
  payorForm: FormGroup
  payorId: any;
  submitted = false;
  // corporateUsers: any

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private payorService: PayorService,
    private activatedRoute: ActivatedRoute,
    private corporateService: CorporateService,
  ) { }

  ngOnInit() {

    this.activatedRoute.params
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((params) => {
        this.payorId = params["id"];
      });

    // this.getcorporateUsers()

    this.payorForm = this.fb.group({
      name: ["", [Validators.required, Validators.minLength(3)]],
      description: ["", [Validators.required, Validators.minLength(5)]],
      status: ["active", Validators.required],
      // association: [[],Validators.required],
    });

    if(this.payorId) {
      this.getPayorById();
    }

  }

  get form() {
    return this.payorForm.controls;
  }


  savePayor() {
    this.submitted = true;

    if (this.payorForm.invalid) return;

    const payload = this.payorForm.value;

    this.payorService.savePayor(this.payorId, payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (res) => {
          if (res) {
            this.router.navigateByUrl("credentialing/payor");
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
  }

  // getcorporateUsers() {
  //   this.corporateService
  //     .getCorporateUsers('active')
  //     .pipe(takeUntil(componentDestroyed(this)))
  //     .subscribe(data => {
  //       if (data && data.length) {
  //         this.corporateUsers = data;
  //       }
  //     }, err => {
  //       sweetAlert('Error', err, 'warning', 'OK');
  //     });
  // }

  ngOnDestroy(): void {
  }

  getPayorById() {
    this.payorService.getPayorById(this.payorId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data: any) => {
          if (data) {
            this.payorForm.patchValue({
              ...data
            });
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
          this.router.navigateByUrl("payor");
        }
      );
  }

}